import { formatSalesValue } from "../../../utils/formatUtils";

const CentralKitchenActualCostingTable = ({
    data,
    actualAccuracy,
    costAccuracy,
    formatNumber,
    otherCost
}) => {
    const items = data?.items_actual_food_costing || [];

    const totalWastage = items.reduce(
        (sum, item) => sum + (parseFloat(item.wastage_cost) || 0),
        0
    );

    const totalDiscrepancy = items.reduce(
        (sum, item) => sum + (parseFloat(item.discrepancy_cost) || 0),
        0
    );

    return (
        <div className="border p-2">
            <div className="font-semibold mb-2 text-lg text-center">
                ACTUAL COSTING
            </div>

            <div className="rounded-md border overflow-x-auto max-h-[400px] tiny-scrollbar">
                <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                Item Name
                            </th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                UOM
                            </th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                Opening
                            </th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                Closing
                            </th>
                            <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                Value
                            </th>
                        </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-100">
                        {items.map((item, i) => (
                            <tr key={i} className="hover:bg-gray-50">
                                <td className="px-3 py-2">{item.item_name}</td>
                                <td className="px-3 py-2">{item.uom}</td>
                                <td className="px-3 py-2">
                                    {formatNumber(item.opening_count)}
                                </td>
                                <td className="px-3 py-2">
                                    {formatNumber(item.physical_count)}
                                </td>
                                <td className="px-3 py-2">
                                    OV={formatSalesValue(item.opening_cost)} : CV=
                                    {formatSalesValue(item.physical_cost)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mt-2 p-1 space-y-1">
                <div className="grid grid-cols-2 gap-16 font-semibold px-2">
                    <div>
                        <div className="grid grid-cols-2 gap-2 items-center">
                            <label>Opening:</label>
                            <input
                                readOnly
                                value={formatSalesValue(data?.summary?.total_opening_cost)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label>Closing:</label>
                            <input
                                readOnly
                                value={formatSalesValue(data?.summary?.total_physical_cost)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label>Cost of Goods Produced:</label>
                            <input
                                readOnly
                                value={formatSalesValue(data?.summary?.total_actual_consumption_cost)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />
                        </div>
                    </div>

                    <div>
                        <div className="grid grid-cols-2 gap-2 items-center">
                            <label>Wastage:</label>
                            <input
                                readOnly
                                value={formatSalesValue(totalWastage)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label>Discrepancies:</label>
                            <input
                                readOnly
                                value={formatSalesValue(totalDiscrepancy)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label>Staff Consumption:</label>
                            <input
                                readOnly
                                value={formatSalesValue(data.employee_meal)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label>Other Cost:</label>
                            <input
                                readOnly
                                value={formatSalesValue(otherCost)}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label>Actual Cost %:</label>
                            <input
                                readOnly
                                value={`${actualAccuracy}%`}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label>Cost Accuracy %:</label>
                            <input
                                readOnly
                                value={`${formatSalesValue(costAccuracy)}%`}
                                className={`border p-1 rounded w-full font-semibold text-center ${costAccuracy < 80
                                    ? "bg-red-200 text-red-800"
                                    : costAccuracy <= 90
                                        ? "bg-yellow-200 text-yellow-800"
                                        : "bg-green-200 text-green-800"
                                    }`}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CentralKitchenActualCostingTable;